import React, {PropTypes} from "react";

class ModalExitView extends React.Component {

  constructor() {
    super();
  }

  render() {
    return (<div className="col-xs-12">
        <div className="col-xs-6">
          <table className="table table-bordered" cellpadding="0" cellspacing="0" border="0">
            <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <tbody>

            <tr>
              <td>Email Id:</td>
              <td>{this.props.employee.emailId}</td>
            </tr>
            <tr>
              <td>Reporting Manager:</td>
              <td>
                {this.props.employee.managerName}</td>
            </tr>
            <tr width={200}>
              <td width={200}>Department:</td>
              <td>{this.props.employee.department}</td>
            </tr>
            <tr>
              <td>Sub Department:</td>
              <td>{this.props.employee.subDepartment}</td>
            </tr>
            <tr>
              <td>Vertical:</td>
              <td>{this.props.employee.vertical}</td>
            </tr>
            <tr>
              <td>Vertical Head:</td>
              <td>{this.props.employee.verticalheadName}</td>
            </tr>
            <tr>
              <td>Function:</td>
              <td>{this.props.employee.function}</td>
            </tr>
            <tr>
              <td>Employee Designation:</td>
              <td>{this.props.employee.designation}</td>
            </tr>
            <tr>
              <td>Office Location:</td>
              <td>{this.props.employee.location}</td>
            </tr>


            </tbody>
          </table>


        </div>
        <div className="col-xs-6">

          <table className="table table-bordered" cellpadding="0" cellspacing="0" border="0">
            <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <tbody>

            <tr>
              <td>Date of Resignation:</td>
              <td>{new Date(this.props.employee.doResignation).toDateString()}</td>
            </tr>
            <tr>
              <td>Last Working Day:</td>
              <td>{this.props.employee.doLeaving != null ? new Date(this.props.employee.doLeaving).toDateString() : 'NA'}</td>
            </tr>
            <tr>
              <td>Notice Period Status</td>
              <td>{this.props.employee.noticePeriodStatus}</td>
            </tr>
            <tr>
              <td>Type Of Exit</td>
              <td>{this.props.employee.type_of_exit}</td>
            </tr>
            <tr>
              <td>Recovery</td>
              <td>{this.props.employee.recovery != 0 ? this.props.employee.recovery : "None"}</td>
            </tr>
            <tr>
              <td>Reasons for leaving</td>
              <td>{this.props.employee.employeeRemarks}</td>
            </tr>
            <tr>
              <td>Remarks</td>
              <td>{this.props.employee.remarks}</td>
            </tr>
            </tbody>
          </table>
        </div>


      </div>
    );
  }
}

ModalExitView.propTypes = {};

export default ModalExitView;





/** WEBPACK FOOTER **
 ** ./src/feature/myProfile/VerticalSS/ModalExitView.js
 **/